import { MembershipRole } from 'src/types';
import { baseFetch } from 'src/utils';

export const inviteUsersAPI = async (
  invitees: { email: string; role: MembershipRole }[],
) => {
  const res = await baseFetch('/api/org/users/invite', {
    method: 'POST',
    body: JSON.stringify({ invitees }),
  });

  if (!res.ok) {
    throw new Error('Failed to invite users');
  }

  // TODO - add error handling for a specific email failing, or all.
  const data = await res.json();

  return data;
};
